import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enTranslation from './locales/en/translation.json';
import heTranslation from './locales/he/translation.json';
import enAuthorization from './locales/en/authorization.json';
import heAuthorization from './locales/he/authorization.json';
import enError from './locales/en/error.json';
import heError from './locales/he/error.json';
import enTutorial from './locales/en/tutorial.json';
import heTutorial from './locales/he/tutorial.json';
import enCommon from './locales/en/common.json';
import heCommon from './locales/he/common.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
      resources: {
        en: {
          translation: enTranslation,
          authorization: enAuthorization,
          error: enError,
          tutorial: enTutorial,
          common: enCommon,
        },
        he: {
          translation: heTranslation,
          authorization: heAuthorization,
          error: heError,
          tutorial: heTutorial,
          common: heCommon,
        },
      },
      lng: 'en',
      fallbackLng: 'en',
      debug: false,
      interpolation: {
          escapeValue: false, // not needed for react as it escapes by default
      }
  });

export default i18n; 